export const SITE_URL = `${window.location.protocol}//${window.location.host}`;
export const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`;
